import { useAppState } from '../../client/providers/AppProvider';
import React from 'react';
import { NeedsOnboardingInformation, usePageRequireAuth } from '../../client/hooks';
import { DashboardFullPageLoading } from '../../components/common/GenericFullPageLoading';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';
import { Espin_Role_Enum } from '../../generated/spin-graphql';
import { CollegeFollowers } from '../../components/dashboard/followers/CollegeFollowers';
import { PlayerFollowersContainer } from '../../components/dashboard/followers/PlayerFollowersContainer';
import { ParentFollowers } from '../../components/dashboard/followers/ParentFollowers';
import { HighSchoolFollowers } from '../../components/dashboard/followers/HighSchoolFollowers';

export default function FollowersPage() {
    const { user } = useAppState();
    usePageRequireAuth({});
    if (!!!user) {
        return <DashboardFullPageLoading />;
    }

    return (
        <DashboardLayout pageTitle="Followers">
            <NeedsOnboardingInformation>
                {user.role === Espin_Role_Enum.EspinPlayerUser && <PlayerFollowersContainer />}
                {user.role === Espin_Role_Enum.EspinCollegeUser && <CollegeFollowers />}
                {user.role === Espin_Role_Enum.EspinParentUser && <ParentFollowers />}
                {user.role === Espin_Role_Enum.EspinHighschoolUser && <HighSchoolFollowers />}
            </NeedsOnboardingInformation>
        </DashboardLayout>
    );
}
